import React from "react";
import { useParams } from "react-router-dom";
import LessonList from "../../components/LessonList/LessonList";

const LessonOfList = () => {
    const { lessonId } = useParams(); 

    return (
        <div className="lesson-container">
            <div>
                <LessonList lessonId={lessonId} /> 
            </div>
        </div>
    );
};

export default LessonOfList;
